module.exports = "/images/sub-ai.png?01675f8e7fafbdfea28f13f7e2c3d094";